import React from 'react';

const TableHead = props => (
    <thead className={props.className}>
        {props.children}
    </thead>
);

export default TableHead;